import { createGlobalStyle } from 'styled-components';
import { landingAdvantagesAtoms } from './landingAdvantagesStyles';
import { landingBaseAtoms } from './landingBaseStyles';
import { landingCalculatorAtoms } from './landingCalculatorStyles';
import { landingDialogsAtoms } from './landingDialogStyles';
import { landingFooterAtoms } from './landingFooterStyles';
import { landingHeaderAtoms } from './landingHeaderStyles';
import { landingHeroAtoms } from './landingHeroStyles';
import { landingNetworkAtoms } from './landingNetworkStyles';
import { landingPartnersAtoms } from './landingPartnersStyles';
import { landingPlansAtoms } from './landingPlansStyles';
import { landingPremiumAtoms } from './landingPremiumStyles';

const landingCss = [
    ...landingBaseAtoms,
    ...landingHeaderAtoms,
    ...landingHeroAtoms,
    ...landingPartnersAtoms,
    ...landingPlansAtoms,
    ...landingNetworkAtoms,
    ...landingCalculatorAtoms,
    ...landingAdvantagesAtoms,
    ...landingPremiumAtoms,
    ...landingFooterAtoms,
    ...landingDialogsAtoms,
]
    .sort((left, right) => left.index - right.index)
    .map((atom) => atom.css)
    .join('\n');

export const LandingGlobalStyled = createGlobalStyle`${landingCss}`;
